export const DEFAULT_BILLING_TYPE = process.env.VUE_APP_DEFAULT_BILLING_TYPE 
    ? process.env.VUE_APP_DEFAULT_BILLING_TYPE : "subscription_1_months"

export const VUE_APP_DEFAULT_VOLUME_TYPE = process.env.VUE_APP_DEFAULT_VOLUME_TYPE 
    ? process.env.VUE_APP_DEFAULT_VOLUME_TYPE : "NVME"